export default __webpack_public_path__ + "static/media/savannah15.5cdae0f8.svg";